/**
 * @fileoverview
 * Detects audit execution / asset-entry process routes where header
 * Branch and Audit Type changes require confirmation.
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import {
  ASSET_AUDIT_ROUTE,
  BRANCH_AUDIT_ROUTE,
  CASH_ROUTE,
  GOLD_VERIFICATION_ROUTE,
  KEY_AUDIT_ROUTE,
  PACKET_INVENTORY_ROUTE,
  REGISTERS_STATUTORY_ROUTE,
  SECURITY_ROUTE,
  SURVEILLANCE_ROUTE,
  TARE_WEIGHT_ROUTE,
  VALUATION_TOOL_ROUTE,
} from '@core/constants/audit-route-segments.const';

/** Path substrings that identify in-progress audit / asset-entry workflows. */
const RESTRICTED_ROUTE_MARKERS: readonly string[] = [
  CASH_ROUTE.PROCESS,
  SECURITY_ROUTE.PROCESS,
  GOLD_VERIFICATION_ROUTE.BRANCH_DETAILS,
  GOLD_VERIFICATION_ROUTE.AUDIT_PROCESS,
  VALUATION_TOOL_ROUTE.PROCESS,
  PACKET_INVENTORY_ROUTE.PROCESS,
  TARE_WEIGHT_ROUTE.PROCESS,
  REGISTERS_STATUTORY_ROUTE.PROCESS,
  ASSET_AUDIT_ROUTE.PROCESS,
  KEY_AUDIT_ROUTE.PROCESS,
  BRANCH_AUDIT_ROUTE.PROCESS,
  `/${SURVEILLANCE_ROUTE.ROUTINE_CHECKING}/${SURVEILLANCE_ROUTE.AUDIT_PROCESS}`,
  `/${SURVEILLANCE_ROUTE.LOAN_PROCESS_CHECKING}/${SURVEILLANCE_ROUTE.AUDIT_PROCESS}`,
  '/asset-entry/add',
  '/asset-entry/acknowledge',
  '/vault-key-entry/new-vault-key-entry',
  '/vault-key-entry/acknowledge',
  'key-movement-sender-audit',
  'key-movement-sender-variance',
  'key-movement-sender-audit-acknowledge',
  'key-movement-receiver-audit',
  'key-movement-receiver-variance',
  'key-movement-receiver-audit-acknowledge',
];

/**
 * True when the current URL is an audit execution or asset-entry process page
 * where switching Branch / Audit Type must be confirmed.
 */
export function isRestrictedHeaderSelectionRoute(url: string): boolean {
  const path = (url ?? '').split('?')[0].split('#')[0];
  if (!path) {
    return false;
  }
  return RESTRICTED_ROUTE_MARKERS.some((marker) => path.includes(marker));
}
